import Vue from 'vue'
import VueRouter from 'vue-router'
import HeaderView from '../components/HeaderView.vue'
import NavMenuView from '../components/NavMenuView.vue'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import HoldManageView from '../views/hold/HoldManageView.vue'
import SimManageView from '../views/sims/SimManageView.vue'
import UserManage from '../views/user/UserManageView.vue'
import SysLogs from '../views/sys/SysLogsView.vue'
import Setting from '../views/sys/SettingView.vue'
import CardSourceManage from '../views/card_source/CardSourceManageView.vue'
import SMSManage from '@/views/sims/SMSManageView.vue'
import SimPackageManage from '@/views/package/SimPackageManage.vue'
import HoldAPIManage from '@/views/hold/HoldAPIManageView.vue'
import GMSimManage from '@/views/sims/GMSimManageView.vue'
import ImportSimsManage from '@/views/sims/ImportSimsManageView.vue'
import RenewalsOrder from '@/views/renewals/RenewalsOrderView.vue'
import PkgPriceConfigManage from '@/views/package/PkgPriceConfigManage.vue'
import PkgRechargeListManage from '@/views/package/PkgRechargeListManage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    components: {
      default: LoginView
    },
    meta: { title: "登录 - 三沐智联卡平台" }
  },
  {
    path: '/home/dashboard',
    name: 'home',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: HomeView
    },
    meta: { title: "首页 - 三沐智联卡平台" }
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: LoginView
    },
    meta: { title: "登录 - 三沐智联卡平台" }
  },
  {
    path: '/hold/manage',
    name: 'hold_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: HoldManageView
    },
    meta: { title: "用户管理 - 三沐智联卡平台" }
  },
  {
    path: '/sims/imports',
    name: 'sim_imports',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: ImportSimsManage
    },
    meta: { title: "批量导入卡 - 三沐智联卡平台" }
  },
  {
    path: '/sims/manage',
    name: 'sim_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: SimManageView
    },
    meta: { title: "SIM卡管理 - 三沐智联卡平台" }
  },
  {
    path: '/gmsims/manage',
    name: 'gmsim_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: GMSimManage
    },
    meta: { title: "国际卡管理 - 三沐智联卡平台" }
  },
  {
    path: '/renewals/order',
    name: 'renewals_order',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: RenewalsOrder
    },
    meta: { title: "续费记录 - 三沐智联卡平台" }
  },
  {
    path: '/cardsource/manage',
    name: 'cardsource_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: CardSourceManage
    },
    meta: { title: "卡源管理 - 三沐智联卡平台" }
  },
  {
    path: '/user/manage',
    name: 'user_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: UserManage
    },
    meta: { title: "账号管理 - 三沐智联卡平台" }
  },
  {
    path: '/sims/sms_manage',
    name: 'sims_sms_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: SMSManage
    },
    meta: { title: "短信管理 - 三沐智联卡平台" }
  },
  {
    path: '/package/manage',
    name: 'package_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: SimPackageManage
    },
    meta: { title: "套餐管理 - 三沐智联卡平台" }
  },
  {
    path: '/package/price_config',
    name: 'pkgprice_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PkgPriceConfigManage
    },
    meta: { title: "套餐价格配置 - 三沐智联卡平台" }
  },
  {
    path: '/package/rechargelist',
    name: 'pkgrecharge_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PkgRechargeListManage
    },
    meta: { title: "套餐续费权限 - 三沐智联卡平台" }
  },
  {
    path: '/hold/api_manage',
    name: 'api_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: HoldAPIManage
    },
    meta: { title: "API管理 - 三沐智联卡平台" }
  },
  {
    path: '/syslogs/manage',
    name: 'sys_logs',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: SysLogs
    },
    meta: { title: "操作日志 - 三沐智联卡平台" }
  },
  {
    path: '/sys/setting',
    name: 'sys_setting',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: Setting
    },
    meta: { title: "个人设置 - 三沐智联卡平台" }
  },
  {
    path: '/about2',
    name: 'about',
    components: {
      default: AboutView
    },
    meta: { title: "About - 三沐智联卡平台" }
  }
]

const router = new VueRouter({
  routes
})

export default router
